import React, { useState } from "react";
import clsx from "clsx";

const ViewQueryButton = (props) => {
  const {
    text,
    type,
    icon,
    imgSrc,
    imgSrcActive,
    labelWrapperClass,
    iconWrapperClass,
    active,
    border,
    iconAlign,
    handleToggle,
    imgStyle,
    disabled,
  } = props;

  const [hover, setHover] = useState(false);
  const _imgSrc = imgSrcActive
    ? hover || active
      ? imgSrcActive
      : imgSrc
    : imgSrc;

  const style = clsx(
    "query-option-button d-flex align-items-center h-100 w-100 " +
      (labelWrapperClass && labelWrapperClass),
    {
      "query-option-button--active": active,
      "query-option-button--border": border,
    }
  );

  return (
    <button
      className={style}
      onClick={() => handleToggle(type)}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      disabled={disabled}
    >
      {iconAlign === "left" ? (
        <>
          {" "}
          {_imgSrc ? (
            <span className={iconWrapperClass}>
              <img
                src={_imgSrc}
                style={{ ...imgStyle, opacity: hover && !active ? 0.6 : "" }}
                alt="Pickaxe"
              />
            </span>
          ) : (
            <span className={iconWrapperClass}>
              <i className={icon} />
            </span>
          )}{" "}
          {text}{" "}
        </>
      ) : (
        <>
          {" "}
          {text}{" "}
          {_imgSrc ? (
            <span className={iconWrapperClass}>
              <img
                src={_imgSrc}
                style={{ ...imgStyle, opacity: hover && !active ? 0.6 : "" }}
                alt="Pickaxe"
              />
            </span>
          ) : (
            <span className={iconWrapperClass}>
              <i className={icon} />
            </span>
          )}{" "}
        </>
      )}
    </button>
  );
};

export default ViewQueryButton;
